import { Reducer } from "react";
import { StoreActionMap, StoreActionKeys } from "./actions";
import { Store } from "./initial";

export const storeReducer: Reducer<Store, StoreActionMap> = (state, action): Store => {
    switch (action.type) {
        case StoreActionKeys.SetMode:
            return { ...state, mode: action.payload };
        case StoreActionKeys.SetSideBar:
            return { ...state, sideBar: action.payload };
        case StoreActionKeys.SetMobile:
            return { ...state, mobile: action.payload };
        default:
            return state;
    }
};